import { motion } from "framer-motion";
import styles from './EventSection.module.css';
import { container, item } from "../../../utils/animations";
import { Trans, useTranslation } from "react-i18next";

export const EventSection = () => {
    const { t } = useTranslation();

    return (
        <motion.div
            className={styles.wrapper}
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            id="events"
        >
            <div className={styles.container}>
                <div className={styles.titleWrapper}>
                    <motion.h1 className={styles.title} variants={item}>
                        <Trans
                            i18nKey="home.eventSection.title"
                            components={[<span className={styles.textCoursive} />]}
                        />
                    </motion.h1>
                    <motion.h2 className={styles.subtitle} variants={item}>
                        {t('home.eventSection.subtitle')}
                    </motion.h2>
                </div>

                <div className={styles.body}>
                    {/* LEFT — big image + Restaurant Lovers card */}
                    <div className={styles.leftWrapper} id="restaurant">
                        <motion.img
                            src={require("../../../../assets/images/events/event_four.png")}
                            alt="Restaurant Lovers"
                            className={styles.leftImage}
                            variants={item}
                        />
                        <motion.div className={styles.card} variants={item}>
                            <h3 className={styles.cardTitle}>
                                {t('home.eventSection.restaurantLovers.title')}
                            </h3>
                            <p className={styles.cardDescription}>
                                {t('home.eventSection.restaurantLovers.description')}
                            </p>
                        </motion.div>
                    </div>

                    {/* RIGHT — Bars & Café + Meetup Lovers */}
                    <div className={styles.rightWrapper}>
                        <div className={styles.rightTop} id="bar">
                            <motion.div className={styles.cardPlain} variants={item}>
                                <h3 className={styles.cardTitle}>
                                    {t('home.eventSection.barsAndCafe.title')}
                                </h3>
                                <p className={styles.cardDescription}>
                                    {t('home.eventSection.barsAndCafe.description')}
                                </p>
                            </motion.div>
                            <motion.img
                                src={require("../../../../assets/images/events/event_five.png")}
                                alt="Bars and Cafe"
                                className={styles.rightImage}
                                variants={item}
                            />
                        </div>

                        <div className={styles.rightBottom} id="meetup">
                            <motion.img
                                src={require("../../../../assets/images/events/event_six.png")}
                                alt="Meetup Lovers"
                                className={styles.rightImage}
                                variants={item}
                            />
                            <motion.div className={styles.cardPlain} variants={item}>
                                <h3 className={styles.cardTitle}>
                                    {t('home.eventSection.meetupLovers.title')}
                                </h3>
                                <p className={styles.cardDescription}>
                                    {t('home.eventSection.meetupLovers.description')}
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};